import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../components/app/Login.vue')
  },
  {
    path: '/',
    redirect: 'login',
    name: 'Layout',
    component: () =>
      import(/* webpackChunkName: "about" */ '@/components/app/Layout.vue'),
    children: [
      {
        path: '',
        name: 'Inicio',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/components/inicio/Index.vue'
          )
      },
      {
        path: '/biblioteca',
        name: 'Biblioteca',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/components/biblioteca/Biblioteca.vue'
          )
      },
      {
        path: '/detallepdf/:rutapdf',
        name: 'DetallePdf',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/components/biblioteca/DetallePdf.vue'
          )
      },
      {
        path: '/detallepdftest/:rutapdf',
        name: 'DetallePdfTest',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/components/biblioteca/PdfEmbebido.vue'
          )
      },
      {
        path: '/foro',
        name: 'Foros',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/components/foro/Foro.vue'
          )
      },
      {
        path: '/detalle-foro/:foroId',
        name: 'Foro',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/components/foro/DetalleForo.vue'
          )
      },
      {
        path: '/detalle-actividad/:actividadId/:activityScheduleId',
        name: 'Actividades',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/components/inicio/DetallesActividad.vue'
          )
      },
      {
        path: '/detalle-curso/:cursoId',
        name: 'Curso',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/components/inicio/DetallesCurso.vue'
          )
      },
      {
        path: '/circular',
        name: 'Circulares',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/components/circulares/Circulares.vue'
          )
      },
      {
        path: '/totalActividades',
        name: 'Total-Actividades',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/components/actividades/Actividades.vue')
      },
      {
        path: '/scorm-viewer/:activityScheduleId',
        name: 'MarcoScorm',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/components/evaluacion/MarcoScorm.vue'
          )
      },
      {
        path: '/detalles-circulares/:id',
        name: 'Circular',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/components/circulares/DetallesCirculares.vue')
      },
      {
        path: '/categoria/:categoriId',
        name: 'Categorías',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/components/biblioteca/SubCategoria.vue'
          )
      },
      {
        path: '/multimedia/:especialidadid/:tipo',
        name: 'Archivos',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/components/biblioteca/DetalleMultimedia.vue'
          )
      },
      {
        path: '/perfil',
        name: 'Perfil',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/components/perfil/perfil.vue'
          )
      },
      {
        path: '/videws',
        name: 'Videos',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/components/videos/Index.vue'
          )
      },
      {
        path: '/vehiculo/camiones',
        name: 'Camiones',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/components/vehiculos/Index.vue'
          )
      },
      {
        path: '/vehiculo/bus',
        name: 'Bus',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/components/vehiculos/Index.vue'
          )
      },
      {
        path: '/vehiculo/:id',
        name: 'Vehículo',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/components/vehiculos/Vehiculo.vue'
          )
      },
      {
        path: '/vehiculo/caracteristicas/:id',
        name: 'Características',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/components/vehiculos/caracteristicas/Caracteristicas.vue'
          )
      },
      {
        path: '/vehiculo/tecnologia/:id',
        name: 'Especificaciones',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/components/vehiculos/tecnologia/Tecnologia.vue'
          )
      },
      {
        path: '/vehiculo/tecnologia/detalles/:id/:tipo',
        name: 'TecnologiaDetalles',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/components/vehiculos/tecnologia/TecnologiaDetalles.vue'
          )
      },
      {
        path: '/vehiculo/calculadora/:id',
        name: 'Calculadora',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/components/vehiculos/calculadora/Calculadora.vue'
          )
      },
      {
        path: '/vehiculo/kits/:id',
        name: 'Kit',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/components/vehiculos/kit/Kit.vue'
          )
      },
      {
        path: '/vehiculo/kit/detalles/:id',
        name: 'Kit Detalles',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/components/vehiculos/kit/KitDetalles.vue'
          )
      },
      {
        path: '/vehiculo/comparar/:id',
        name: 'Comparar',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/components/vehiculos/comparar/Comparar.vue'
          )
      },
      {
        path: '/evaluacion/:activityScheduleId',
        name: 'Evaluacion',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/components/evaluacion/Evaluacion.vue'
          )
      },
      {
        path: '/resultado-evaluacion/:reviewsAnswerId',
        name: 'ResultadoEvaluacion',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/components/evaluacion/ResultadoEvaluacion.vue'
          )
      },
      {
        path: '/entregar-actividad/:activityScheduleId',
        name: 'EntregarActividad',
        meta: {
          requiresAuth: true
        },
        component: () =>
          import(
            /* webpackChunkName: "about" */ '@/components/actividades/RespuestaActividad.vue'
          )
      }]
  },
  {
    path: '/salir',
    name: 'Salir',
    component: () => import('@/components/app/Salir.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// eslint-disable-next-line @typescript-eslint/no-empty-function
router.beforeEach(async (to, from, next) => {
  if (to.meta?.requiresAuth && !localStorage.getItem('token')) {
    next({
      path: '/login',
      replace: true
    })
  } else if (to.name === 'Login' && localStorage.getItem('token')) {
    next({
      path: '/',
      replace: true
    })
  } else {
    next()
  }
})

export default router
